import { render, staticRenderFns } from "./SelectorsList.vue?vue&type=template&id=4b6a7571&"
import script from "./SelectorsList.vue?vue&type=script&lang=ts&"
export * from "./SelectorsList.vue?vue&type=script&lang=ts&"
import style0 from "./SelectorsList.vue?vue&type=style&index=0&id=4b6a7571&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports